import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { suppliersAPI } from '../api/endpoints.js'
import { useToast } from '../contexts/ToastContext'
import { useAuth } from '../contexts/AuthContext'

function SuppliersPage() {
  const navigate = useNavigate()
  const { addToast } = useToast()
  const { isAuthenticated } = useAuth()
  const [suppliers, setSuppliers] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login')
      return
    }
    loadSuppliers()
  }, [isAuthenticated, navigate])

  const loadSuppliers = async () => {
    try {
      setLoading(true)
      const response = await suppliersAPI.getAll()
      console.log('=== FORNECEDORES CARREGADOS ===')
      console.log('Resposta:', response)
      console.log('Fornecedores:', response.data)
      console.log('Total:', response.data?.length)
      console.log('===============================')
      setSuppliers(response.data || [])
    } catch (error) {
      console.error('Error loading suppliers:', error)
      addToast('Erro ao carregar fornecedores', 'error')
    } finally {
      setLoading(false)
    }
  }

  const filteredSuppliers = suppliers.filter(supplier => {
    const searchLower = searchTerm.toLowerCase()
    return (
      supplier.trade_name?.toLowerCase().includes(searchLower) ||
      supplier.legal_name?.toLowerCase().includes(searchLower) ||
      supplier.email?.toLowerCase().includes(searchLower) ||
      supplier.phone?.includes(searchTerm) ||
      supplier.specialty?.toLowerCase().includes(searchLower)
    )
  })

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-dark-bg-primary flex items-center justify-center transition-colors">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 dark:border-dark-accent-green mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-dark-text-secondary">Carregando fornecedores...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-bg-primary py-8 transition-colors">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="bg-white dark:bg-dark-bg-secondary rounded-lg shadow-md dark:shadow-none p-6 mb-6 border border-gray-200 dark:border-dark-border-primary transition-colors">
          <div className="flex items-center justify-between mb-4">
            <button
              onClick={() => navigate('/app')}
              className="flex items-center text-blue-600 dark:text-dark-accent-green hover:text-blue-700 dark:hover:text-dark-accent-greenLight transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Voltar ao Dashboard
            </button>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 dark:text-dark-text-primary mb-2">
            Fornecedores
          </h1>
          <p className="text-gray-600 dark:text-dark-text-secondary">
            Total de {suppliers.length} fornecedor{suppliers.length !== 1 ? 'es' : ''} cadastrado{suppliers.length !== 1 ? 's' : ''}
          </p>
        </div>

        {/* Search Bar */}
        <div className="bg-white dark:bg-dark-bg-secondary rounded-lg shadow-md dark:shadow-none p-4 mb-6 border border-gray-200 dark:border-dark-border-primary transition-colors">
          <div className="relative">
            <input
              type="text"
              placeholder="Buscar por nome, email, telefone ou especialidade..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 pl-10 border border-gray-300 dark:border-dark-border-primary rounded-md bg-white dark:bg-dark-bg-primary text-gray-900 dark:text-dark-text-primary placeholder-gray-400 dark:placeholder-dark-text-muted focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-dark-accent-green transition-colors"
            />
            <svg
              className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 dark:text-dark-text-muted"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>

        {/* Suppliers List */}
        <div className="bg-white dark:bg-dark-bg-secondary rounded-lg shadow-md dark:shadow-none p-6 border border-gray-200 dark:border-dark-border-primary transition-colors">
          {filteredSuppliers.length === 0 ? (
            <div className="text-center py-12">
              <svg
                className="mx-auto h-12 w-12 text-gray-400 dark:text-dark-text-muted"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-dark-text-primary">
                {searchTerm ? 'Nenhum fornecedor encontrado' : 'Nenhum fornecedor cadastrado'}
              </h3>
              <p className="mt-1 text-sm text-gray-500 dark:text-dark-text-secondary">
                {searchTerm ? 'Tente buscar com outros termos' : 'Comece cadastrando fornecedores no sistema'}
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredSuppliers.map((supplier) => (
                <div
                  key={supplier.id}
                  className="border border-gray-200 dark:border-dark-border-primary rounded-lg p-4 hover:bg-gray-50 dark:hover:bg-dark-bg-tertiary hover:border-blue-300 dark:hover:border-dark-accent-green transition-colors"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <h3 className="font-semibold text-gray-800 dark:text-dark-text-primary text-lg mb-1">
                        {supplier.trade_name || supplier.legal_name}
                      </h3>
                      {supplier.trade_name && supplier.legal_name && supplier.trade_name !== supplier.legal_name && (
                        <p className="text-xs text-gray-500 dark:text-dark-text-muted mb-2">
                          {supplier.legal_name}
                        </p>
                      )}
                    </div>
                    <div className={`px-2 py-1 rounded text-xs font-medium ${
                      supplier.supplier_status_id === 1 
                        ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' 
                        : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400'
                    }`}>
                      {supplier.supplier_status_id === 1 ? 'Ativo' : 'Inativo'}
                    </div>
                  </div>

                  {supplier.specialty && (
                    <div className="mb-3">
                      <span className="inline-block bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400 px-2 py-1 rounded text-xs font-medium">
                        {supplier.specialty}
                      </span>
                    </div>
                  )}

                  <div className="space-y-2">
                    {supplier.email && (
                      <div className="flex items-center text-sm text-gray-600 dark:text-dark-text-secondary">
                        <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <span className="truncate">{supplier.email}</span>
                      </div>
                    )}

                    {supplier.phone && (
                      <div className="flex items-center text-sm text-gray-600 dark:text-dark-text-secondary">
                        <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        <span>{supplier.phone}</span>
                      </div>
                    )}

                    {supplier.document && (
                      <div className="flex items-center text-sm text-gray-600 dark:text-dark-text-secondary">
                        <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <span className="truncate">{supplier.document}</span>
                      </div>
                    )}
                  </div>

                  {supplier.created_at && (
                    <div className="mt-3 pt-3 border-t border-gray-200 dark:border-dark-border-primary">
                      <p className="text-xs text-gray-500 dark:text-dark-text-muted">
                        Cadastrado em {new Date(supplier.created_at).toLocaleDateString('pt-BR')}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SuppliersPage
